<template>
  <!-- Public body wrapper - no authenticated components -->
</template>

<script setup>
import { onMounted } from "vue";
import store from "@/src/store/index.js";
import { themeTypes } from "@/src/constants/themeConstants.js";

const initializeTheme = async () => {
  if (document.documentElement.getAttribute("data-theme")) {
    return;
  }

  // For public pages, use light theme by default
  await store.dispatch("theme/initTheme", themeTypes.LIGHT);
};

onMounted(async () => {
  await initializeTheme();
});
</script>
